import { render, staticRenderFns } from "./FolderCreateModal.vue?vue&type=template&id=def64606&scoped=true"
import script from "./FolderCreateModal.vue?vue&type=script&lang=js"
export * from "./FolderCreateModal.vue?vue&type=script&lang=js"
import style0 from "./FolderCreateModal.vue?vue&type=style&index=0&id=def64606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def64606",
  null
  
)

export default component.exports